<template>
  <div class="PostFormGroupPhotos">
    <h3>{{ title || $t("posts.components.picturesTitle") }}</h3>
    <p v-html="$t('posts.components.picturesText')"/>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PostFormGroupPhotos',
  props: {
    value: { type: Object, default: () => ({}) },
    title: String,
    description: String
  }
}
</script>
